module.exports = __webpack_public_path__ + "static/media/Alpha-iQ-RA-6300-iQ.a7fb2bd4.png";